import { Converter } from '../types/converter';

export const speedConverter: Converter = {
  id: 'speed',
  name: 'Speed Converter',
  icon: 'Timer',
  categories: ['common', 'engineering'],
  units: [
    // Base SI unit
    { name: 'Meter/second', symbol: 'm/s', factor: 1 },
    
    // Common speed units
    { name: 'Kilometer/hour', symbol: 'km/h', factor: 0.277777778 },
    { name: 'Mile/hour', symbol: 'mi/h', factor: 0.44704 },
    { name: 'Meter/hour', symbol: 'm/h', factor: 0.000277778 },
    { name: 'Meter/minute', symbol: 'm/min', factor: 0.016666667 },
    { name: 'Kilometer/minute', symbol: 'km/min', factor: 16.666667 },
    { name: 'Kilometer/second', symbol: 'km/s', factor: 1000 },
    
    // Smaller units
    { name: 'Centimeter/hour', symbol: 'cm/h', factor: 2.777778e-6 },
    { name: 'Centimeter/minute', symbol: 'cm/min', factor: 0.000166667 },
    { name: 'Centimeter/second', symbol: 'cm/s', factor: 0.01 },
    { name: 'Millimeter/hour', symbol: 'mm/h', factor: 2.777778e-7 },
    { name: 'Millimeter/minute', symbol: 'mm/min', factor: 1.666667e-5 },
    { name: 'Millimeter/second', symbol: 'mm/s', factor: 0.001 },
    
    // Imperial/US units
    { name: 'Foot/hour', symbol: 'ft/h', factor: 8.466667e-5 },
    { name: 'Foot/minute', symbol: 'ft/min', factor: 0.00508 },
    { name: 'Foot/second', symbol: 'ft/s', factor: 0.3048 },
    { name: 'Yard/hour', symbol: 'yd/h', factor: 0.000254 },
    { name: 'Yard/minute', symbol: 'yd/min', factor: 0.01524 },
    { name: 'Yard/second', symbol: 'yd/s', factor: 0.9144 },
    { name: 'Mile/minute', symbol: 'mi/min', factor: 26.8224 },
    { name: 'Mile/second', symbol: 'mi/s', factor: 1609.344 },
    
    // Maritime units
    { name: 'Knot', symbol: 'kn', factor: 0.514444444 },
    { name: 'Knot (UK)', symbol: 'kn (UK)', factor: 0.514773333 },
    
    // Special velocities
    { name: 'Velocity of light in vacuum', symbol: 'c', factor: 299792458 },
    { name: 'Cosmic velocity - first', symbol: 'v₁', factor: 7900 },          // Earth orbital velocity
    { name: 'Cosmic velocity - second', symbol: 'v₂', factor: 11200 },        // Earth escape velocity
    { name: 'Cosmic velocity - third', symbol: 'v₃', factor: 16700 },         // Solar System escape velocity
    { name: "Earth's velocity", symbol: 'v⊕', factor: 29784.8 },              // Around the Sun
    
    // Sound velocities
    { name: 'Velocity of sound in pure water', symbol: 'c_water', factor: 1497 },  // at 20°C
    { name: 'Velocity of sound in sea water', symbol: 'c_sea', factor: 1500 },     // at 20°C, 10m deep
    { name: 'Mach (20°C, 1 atm)', symbol: 'M', factor: 343 },                      // Speed of sound in air
    { name: 'Mach (SI standard)', symbol: 'M_SI', factor: 340.3 }                  // ISA standard conditions
  ]
};
